import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { CouchbaseTableDataset } from 'app/model/dataset/couchbase.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'CouchbaseSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(CouchbaseTableDataset) }
})
export class CouchbaseCopySource extends TabularCopySource {
}
